import { Language } from './types';

const BASE_LANGUAGE_LABELS = {
  wMXN: 'MXN Mexican Pesos',
  wCOP: 'COP Colombian Pesos',
  wUSD: 'USD United States Dollars',
  wEUR: 'EUR Euros',
  wGBP: 'GBP British Pounds',
  wCAD: 'CAD Canadian Dollars',
  wHKD: 'HKD Hong Kong Dollars',
  wJPY: 'JPY Japanese Yens',
  wCHF: 'CHF Swiss Francs',
  wBRL: 'BRR Brazilian Reals',
  walletHeader: 'Wallet',
  walletTitle: 'Combined Balance',
  walletDisclaimer:
    'This is an estimation of your balance, based on currency prices in {{currency}} on {{date}}.',
  walletViewAll: 'View each wallet balance',
  walletConvertHeader: 'Convert',
  walletConfigureConvert: 'Configure conversions',
  walletConvertMessage:
    'Convert the amount you want into a different currency.',
  walletConvertDisclaimer:
    'You can only do payments from {{currency}} to {{destiny}}',
  walletConvertFrom: 'From {{origin}}',
  walletConvertTo: 'To {{destiny}}',
  walletExchangeRate: 'Exchange rate',
  walletWillUpdate: 'Rates will update in',
  walletSeconds: '{{seconds}} seconds',
  walletTotalToConvert: 'Total converted',
  walletExRateBuy: 'Buy {{currency}}: ',
  walletExRateSell: 'Sell {{currency}}: ',
  walletConvertButton: 'Make conversion',
  walletConvertSuccess: 'Conversion completed.',
  walletFromText: 'Original amount: ',
  walletToText: 'Converted amount: ',
  walletAmountConversionError:
    'You can only convert {{maxAmount}} {{currency}}',
  walletReverseConversion: 'Reverse order',
  walletLockedBalance: 'Locked balance',
  walletCalculateDisclaimer: 'The value shown is rounded.',
  walletCalculateDisclaimerMessage:
    'The calculation was made with {{amount}} {{currency}}',
  createNewWallet: 'Create global account in {{currenciesToCreate}}',
  availableWalletsToCreateConnectors: 'or',
};

type LabelsLanguage = keyof typeof BASE_LANGUAGE_LABELS;

const WALLETS_LANGUAGE_LABELS: Record<
  Language,
  Record<LabelsLanguage, string>
> = {
  EN: BASE_LANGUAGE_LABELS,
  ES: {
    wMXN: 'MXN Pesos Mexicanos',
    wCOP: 'COP Pesos Colombianos',
    wUSD: 'USD Dólares Estadounidenses',
    wEUR: 'EUR Euros',
    wGBP: 'GBP Libras Esterlinas',
    wCAD: 'CAD Dólares Canadienses',
    wHKD: 'HKD Dólares de Hong Kong',
    wJPY: 'JPY Yenes Japoneses',
    wCHF: 'CHF Francos Suizos',
    wBRL: 'BRR Reales Brasileños',
    walletHeader: 'Wallet',
    walletTitle: 'Balance Combinado',
    walletDisclaimer:
      'Esta es una estimación de tu saldo, basada en los precios de tus divisas en {{currency}} al {{date}}.',
    walletViewAll: 'Ver balance de cada wallet',
    walletConvertHeader: 'Convertir',
    walletConfigureConvert: 'Configurar conversiones',
    walletConvertMessage:
      'Convierte la cantidad que quieras a una moneda diferente.',
    walletConvertDisclaimer:
      'Solo puedes realizar pagos de {{currency}} a {{destiny}}',
    walletConvertFrom: 'De {{origin}}',
    walletConvertTo: 'A {{destiny}}',
    walletExchangeRate: 'Tasa de cambio',
    walletWillUpdate: 'Las tarifas se actualizarán en',
    walletSeconds: '{{seconds}} segundos',
    walletTotalToConvert: 'Total convertido',
    walletExRateBuy: 'Compra {{currency}}: ',
    walletExRateSell: 'Venta {{currency}}: ',
    walletConvertButton: 'Realizar conversión',
    walletConvertSuccess: 'Conversión completada.',
    walletFromText: 'Monto original: ',
    walletToText: 'Monto convertido: ',
    walletAmountConversionError:
      'Solo puedes convertir {{maxAmount}} {{currency}}',
    walletReverseConversion: 'Invertir orden',
    walletLockedBalance: 'Balance bloqueado',
    walletCalculateDisclaimer: 'El valor mostrado es redondeado.',
    walletCalculateDisclaimerMessage:
      'El cálculo se realizó con {{amount}} {{currency}}',
    createNewWallet: 'Crear cuenta global en {{currenciesToCreate}}',
    availableWalletsToCreateConnectors: 'o',
  },
};

export default WALLETS_LANGUAGE_LABELS;
